// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { StateTimerDefinition_abstract } from './../abstract/SagaTimers/StateTimerDefinition_abstract';
export class StateTimerDefinition extends StateTimerDefinition_abstract {}
